<template>
  <component
    :is="tag"
    :id="id"
    role="group"
    class="input-group"
    :class="{ [`input-group-${size}`]: size }"
  >
    <BInputGroupPrepend v-if="prepend">
      <BInputGroupText>
        {{ prepend }}
      </BInputGroupText>
    </BInputGroupPrepend>
    <slot />
    <BInputGroupAppend v-if="append">
      <BInputGroupText>
        {{ append }}
      </BInputGroupText>
    </BInputGroupAppend>
  </component>
</template>

<script>
import BInputGroupAppend from './BInputGroupAppend.vue'
import BInputGroupPrepend from './BInputGroupPrepend.vue'
import BInputGroupText from './BInputGroupText.vue'
export default {
  name: 'BInputGroup',
  components: {
    BInputGroupAppend,
    BInputGroupText,
    BInputGroupPrepend
  },
  props: {
    tag: {
      type: String,
      default: 'div'
    },
    size: {
      type: String,
      default: null,
      validator: value => {
        return ['sm', 'lg'].includes(value)
      }
    },
    id: {
      type: String,
      default: null
    },
    append: {
      type: String,
      default: null
    },
    prepend: {
      type: String,
      default: null
    }
  }
}
</script>
